import e from "react";
import { ITCLauncherWrapper as o } from "../ITCAppLauncher/ITCLauncherWrapper.js";
import { Image as a } from "../../general/Image/Image.js";
import { componentName as t } from "../../../utils/bem/index.js";
import { ProfileItems as i } from "./components/ProfileItems/ProfileItems.js";
import { HelpItems as n } from "./components/HelpItems/HelpItems.js";
function r(r) {
  return e.createElement("div", {
    className: t("top-bar", r.className)
  }, e.createElement("div", {
    className: "top-bar__logo"
  }, e.createElement("a", {
    href: r.logoUrl
  }, e.createElement(a, {
    img: r.logo,
    altText: r.logoAltText
  }))), e.createElement("div", {
    className: "top-bar__center"
  }, r.children), !r.disableRightTopbar && e.createElement("div", {
    className: "top-bar__right"
  }, r.helpDataList && e.createElement(n, {
    helpDataList: r.helpDataList,
    dataVimeo: r.dataVimeo,
    tagColors: r.tagColors,
    whatsNewData: r.whatsNewData
  }), e.createElement(i, {
    avatar: r.avatar,
    username: r.username,
    email: r.email,
    mobile: r.mobile,
    popoverClassName: r.popoverClassName,
    onAccountMenuOpen: r.onAccountMenuOpen,
    midSectionProfileData: r.midSectionProfileData,
    impersonated: r.impersonated,
    logoutLink: r.logoutLink,
    onLogout: r.onLogout,
    profileSettingsLink: r.profileSettingsLink,
    topSectionProfileData: r.topSectionProfileData,
    bottomSectionProfileData: r.bottomSectionProfileData
  }), !r.mobile && e.createElement(o, {
    k1Token: r.k1Token,
    isK1SsoSession: r.isK1SsoSession,
    useQaLauncherApi: r.useQaLauncherApi,
    launcherApiVersion: r.launcherApiVersion,
    ssoVersion: r.ssoVersion,
    hasAdminPermissions: r.hasAdminPermissions,
    isK1LoginEnabled: r.isK1LoginEnabled,
    onK1LoginEnable: r.onK1LoginEnable,
    onK1ButtonClick: r.onK1ButtonClick
  })));
}
r.displayName = "TopBar", r.defaultProps = {
  ssoVersion: 1
};
export { r as TopBar };